module.exports = __webpack_public_path__ + "img/tianmao.05a7b940.png";